export const MOBILE_DEVICE_BREAKPOINT = 1128;
export const CUSTOM_PRICING_LABEL = 'Custom';
export const TABLET_DEVICE_BREAKPOINT = 768;
export const PHONE_DEVICE_BREAKPOINT = 576;
export const PRESS_LOGO_URL = 'https://assets.gcore.pro/site/press/logo/';
export const TOP_OFFSET = 123;
export const TOP_OFFSET_MOBILE = 82;
